export const DOC_TYPE_POLICY_DOCUMENT = 'POLICY_DOCUMENT'

export const POLICY_HOLDER_TYPE = {
  INDIVIDUAL: 'INDIVIDUAL',
  CORPORATE: 'CORPORATE',
}

export const POLICYHOLDERTYPE_SMALLCASE = {
  INDIVIDUAL: 'individual',
  CORPORATE: 'corporate',
}

export const INSURANCE_CATEGORY = {
  ACCIDENTAL: 'accidental',
}

export const RISK_LEVEL_CONSTANTS = {
  MISSING: 'Missing',
  CRITICAL: 'Critical',
  AVERAGE: 'Average',
  NORMAL: 'Normal',
  GOOD: 'Good',
  EXCELLENT: 'Excellent',
}

export const MOTOR_SUB_CATEGORY = {
  TWO_WHEELER: 'TWO-WHEELER',
  FOUR_WHEELER: 'FOUR-WHEELER',
  CAR: 'CAR',
  BIKE: 'BIKE',
  MOTOR: 'MOTOR',
}

export const ACTION_CONST = {
  BUY: 'BUY',
  UPLOAD: 'UPLOAD',
}

export const VIEWEMPLOYEE = 'viewEmployee'

export const PHONE = 'phone'

export const ISVALIDPHONE = 'isPhoneValid'

export const CANNOT_RAISE_REQUEST =
  'Cannot raise the request as there is no email id associated to the account.'

export const REQUEST_CAPTURED =
  'Your request has been captured. Our team will get in touch with you.'

export const ERROR_ENCOUNTERED_WHILE_SUBMIT =
  'Encountered an error while submitting the request.'

export const ENDORSEMENT_TYPES = {
  EMPLOYEE_ADDITION_DELETION: 'Employee Addition & Deletion',
  ASSET_ADDITION_DELETION: 'Asset Addition & Deletion',
  INDIVIDUAL_ADDITION_DELETION: 'Individual Addition & Deletion',
  ENDORSEMENT_ADDITION_DELETION: 'Endorsement-Addition/ Deletion',
  EMPLOYEE_DETAIL_CORRECTION: 'Employee Details Correction',
  ASSET_DETAIL_CORRECTION: 'Asset Details Correction',
  INDIVIDUAL_DETAIL_CORRECTION: 'Individual Details Correction',
  ENDORSEMENT_DETAIL_CORRECTION: 'Endorsement-Details Corrections',
  ENDORSEMENT_POLICY_CORRECTION: 'Endorsement-Policy Corrections',
}

export let options = {
  day: 'numeric',
  month: 'short',
  year: '2-digit',
}
export let options1 = {
  hour: 'numeric',
  minute: '2-digit',
}

export const VERIFICATION_PENDING = 'Verification Pending'

export const RENEWAL_POLICY_UNDER_VERIFICATION =
  'Renewal Policy under digitalization'

export const CLICK_TO_DOWNLOAD = 'Click to download the document'

export const NOTIFICATION_SETTINGS_MSG = {
  NOTIFICATION_SETTINGS_UPDATED: 'Notification Settings have been updated.',
  ENCOUNTERED_ERROR:
    'Encountered an error while updating Notification Settings.',
  MOBILE_NO_NOT_UPDATED:
    'Mobile number not updated. Please try after some time',
  PLEASE_TRY_AGAIN_AFTER_SOMETIME: 'Please try again after some time.',
  NO_REPORTS: 'No reports available',
  ENCOUNTERED_ERROR_ON_REPORTS: 'Encountered an error while fetching reports.',
  ENCOUNTERED_ERROR_ON_REQUEST_RAISED:
    'Encountered an error while raising the request.',
}

export const INVALID_NUMBER = 'Invalid mobile number'

export const REPORT_DOWNLOAD = 'REPORT_DOWNLOAD'

export const CLAIM_REQUEST_RAISED =
  'Claim Request has been raised successfully. Please check your email for confirmation.'

export const CLIENT = {
  CORPORATE: 'CORPORATE',
}

export const HOME = 'home'

export const DIGITALIZING = 'DIGITALIZING'

export const CLIENT_SMALLCASE = {
  CORPORATE: 'corporate',
  INDIVIDUAL: 'individual',
}

export const NEW_VEHICLE_ENQUIRY =
  'New Vehicle Inquiry Request has been raised successfully. Please check your email for confirmation.'

export const POLICY_DOCUMENT = 'POLICY_DOCUMENT'

export const membersColumns = ['Name', 'Age', 'Relation']
export const membersColumnsCEO = ['Id', 'Name', 'Age', 'Relation']
export let sortField = 'updatedOn'
export let sortOrder = 'desc'

export const YET_TO_BE_UPLOAD = 'Yet to be uploaded'
export const PLEASE_GET_IN_TOUCH_WITH_HR =
  'Please get in touch with your HR for your Health Card.'
export const FINANCIAL_PROTECTION_NOTIFICATION =
  'Financial Protection Guidance Request has been raised successfully. Please check your email for confirmation.'

export const tabTypes = {
  MARRIAGE: 'MARRIAGE',
  NEW_BORN: 'NEW_BORN',
}

export const MATERNITY_COVERAGE =
  'Maternity Coverage counselling Request has been raised successfully. Please check your email for confirmation.'
